/**
 * Ops Vietnamese short labels for business status codes.
 * Tone: `resolveStatusTone` · Field op shorten: `mesOpStatusLabel` (override via StatusBadge label=).
 */
const STATUS_LABEL: Record<string, string> = {
  // Master / enablement
  Active: "Đang hoạt động",
  Inactive: "Không hoạt động",
  Enabled: "Đang hoạt động",
  Disabled: "Không hoạt động",
  Locked: "Khóa",

  // Commercial / txn
  Draft: "Nháp",
  Published: "Đang phát hành",
  Retired: "Đã ngừng",
  Confirmed: "Đã xác nhận",
  /** FIN Receipt — thu một phần Remaining */
  Partial: "Thu một phần",
  Shipped: "Đã giao",
  Planned: "Đã lên kế hoạch",
  InProduction: "Đang sản xuất",
  Ready: "Sẵn sàng",
  Completed: "Hoàn tất",
  OnHold: "Tạm giữ",
  Cancelled: "Đã hủy",
  PartiallyReceived: "Nhận một phần",
  Received: "Đã nhận",
  Closed: "Đã đóng",
  Posted: "Đã ghi sổ",
  Void: "Đã hủy",
  Shortage: "Thiếu",

  // Workflow (also used in filters; WorkflowStatusBadge has same family)
  Submitted: "Đã gửi duyệt",
  PendingApproval: "Chờ duyệt",
  Approved: "Đã duyệt",
  Rejected: "Từ chối",
  Converted: "Đã chuyển PO",
  Effective: "Hiệu lực",
  /** ENG versioned masters — bản bị thay khi bản mới hiệu lực */
  Obsolete: "Hết hiệu lực",
  /** DocumentVersion — bản bị thay khi phát hành version mới */
  Superseded: "Đã thay thế",

  // Planning / MES batch
  Released: "Đã phát hành",
  Issued: "Đã cấp phát",
  InProgress: "Đang chạy",
  Paused: "Tạm dừng",
  Hold: "Tạm giữ",
  Open: "Đang mở",
  Done: "Hoàn tất",
  Skipped: "Bỏ qua",
  Blocked: "Tạm giữ",

  // Lot QC / inspection
  Pending: "Chờ",
  Passed: "Đạt",
  Failed: "Không đạt",
  Pass: "Đạt",
  Fail: "Không đạt",
  Conditional: "Có điều kiện",

  // Lot inventory
  Available: "Khả dụng",
  Reserved: "Đã giữ",
  Quarantine: "Cách ly",
  Expired: "Hết hạn",
  Soon: "Sắp hết",
  Consumed: "Đã dùng",
  Disposed: "Đã hủy",

  // QA decision
  Release: "Phê duyệt",
  Reject: "Từ chối",

  // NCR
  DispositionPending: "Chờ xử lý",

  // Email message log
  Simulated: "Giả lập",
  Sent: "Đã gửi",
  // Failed already = "Không đạt" (QC); email KPI uses custom label "Thất bại"

  // Notifications
  Read: "Đã đọc",
  Unread: "Chưa đọc",

  // Severity / Priority
  Critical: "Nghiêm trọng",
  High: "Nặng",
  Major: "Nặng",
  Medium: "Trung bình",
  Low: "Nhẹ",
  Minor: "Nhẹ",

  // NCR Source
  Inspection: "Kiểm tra chất lượng",
  Manual: "Thủ công",
  Customer: "Khách hàng",
  Supplier: "Nhà cung cấp",
  Internal: "Nội bộ",
};

function normalizeKey(status: string): string {
  return status.trim().toLowerCase().replace(/[\s_-]+/g, "");
}

const STATUS_LABEL_NORM: Record<string, string> = Object.fromEntries(
  Object.entries(STATUS_LABEL).map(([k, v]) => [normalizeKey(k), v]),
);

/** Vietnamese short label for a status code; unknown → raw code. */
export function statusLabel(status: string): string {
  const raw = status.trim();
  if (!raw || raw === "—") return raw || status;
  return STATUS_LABEL[raw] ?? STATUS_LABEL_NORM[normalizeKey(raw)] ?? status;
}

/** Filter options: same labels as StatusBadge. */
export function statusFilterOptions(
  values: readonly string[],
): Array<{ value: string; label: string }> {
  return values.map((value) => ({ value, label: statusLabel(value) }));
}
